"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M11.562 5.732A2.5 2.5 0 0 1 13.329 5h4.172a1.5 1.5 0 0 1 1.5 1.5v4.172a2.5 2.5 0 0 1-.732 1.767l-6.5 6.5a2.5 2.5 0 0 1-3.536 0l-3.171-3.171a2.5 2.5 0 0 1 0-3.536zM16 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
}), 'DiscountTagFilled');
